import apiClient from '@/config/api/axios'
import { AUTH_SIGNUP } from '@/config/api/endpoints'
import { normalizeLoginResponse } from './normalizeLoginResponse.js'

// Returns either a ready session (autoconfirm projects return tokens) or a
// pending-verification result the UI can surface.
export async function signupWithEmailPassword({ email, password, fullName }) {
  const { data } = await apiClient.post(
    AUTH_SIGNUP,
    { email, password, full_name: fullName },
    { timeout: 30_000 },
  )
  if (data?.access_token) return normalizeLoginResponse(data)
  return {
    success: true,
    emailConfirmationRequired: !data?.email_confirmed,
    message: data?.message || 'Account created.',
    user: data?.user || null,
  }
}
